import xmlutils from './xmlutil.js'

export default {

  createNode(type,id) {
    var node = {id: id ,size:[120,60]}
    if (type == 'printorder') {
      node.label = 'Auftrag drucken';
      node.style = { fill: 'rgb(219,227,0)' };
    } else if (type == 'chatbot') {
      node.label = 'Chat Bot';
      node.style = { fill: 'rgb(247,184,255)' };
    } else if (type == 'userTask') {
      node.label = 'Formular';
      node.style = { fill: 'rgb(170,209,250)' };
    } else if (type == 'scriptTask') {
      node.label = 'Skript';
      node.style = { fill: 'rgb(184,122,0)' };
    } else if (type == 'webservice') {
      node.label = 'Web Service';
      node.style = { fill: 'rgb(0,184,147)' };
    } else if (type == 'startEvent') {
      node.label = 'Start';
      node.style = { fill: 'green' };
      node.type = 'circle';
      node.size = 50;
    } else if (type == 'exclusiveGateway') {
      node.label = '';
      node.style = { fill: 'grey' };
      node.labelCfg = { position: 'bottom', style: { fill: 'black', fontSize: 12 }};
      node.type  = 'diamond';
      node.size  = 50;
    } else if (type == 'endEvent') {
      node.label = 'Ende';
      node.style = { fill: 'red' };
      node.type = 'circle';
      node.size = 50;
    } else {
      node = false;
    }
    return node;
  },

  // map json process data to the graph
  process2graph(document) {
    var result = { process: {}, dict: {}, graph: { nodes: [] , edges: [] } };

    // check param
    if (!document || !document.root) {
      console.log('no process data found');
      return;
    }

    // check base process attributes

    // check process node
    var proc = xmlutils.firstchild(document.root.children,'process');
    if (!proc)  {
      console.log('failed proc node');
      return;
    }

    // check diagram node
    var graph = xmlutils.firstchild(document.root.children,'BPMNDiagram')
    if (!graph)  {
      console.log('failed graph node');
      return;
    }

    console.log('result: ');

    result.process = proc;

    var i;
    for (i in proc.children) {
      var entry = proc.children[i];
      var id    = entry.attributes['id'].value;
      result.dict[id] = entry;
    }

    // get from first plane (diagram) all elements
    for (i in graph.children[0].children) {
      var gnode = graph.children[0].children[i];
      var eid   = gnode.attributes['bpmnElement'].value;
      this.importBPMNNode(result,gnode,eid);
    }

    console.log(result);

    return result;
  },

  // connector specific bpmn node import
  importBPMNNode(data,node,id) {
    var lelem = data.dict[id];

    if (!lelem) {
      console.log('Fehler konnte ' + id + ' Objekt nicht finden.');
      return;
    }

    var shape = false;
    var gnode = false;
    var gedge = false;

    // check edge
    if (lelem.nodeName == 'sequenceFlow') {
      gedge = { id: lelem.attributes["id"].value, source: lelem.attributes['sourceRef'].value, target: lelem.attributes['targetRef'].value, type: 'polyline', style: { } };
      // add control points
      var vertices = [];
      if (node.children) {
        // ignore first and last waypoint graph don't need start and end node point
        var max = node.children.length-1;
        for (var i in node.children) {
          if (i==0 || i == max) continue;
          var c = node.children[i];
          console.log(c.localName);
          if (c.localName == 'waypoint') {
            vertices.push({ x: Number(c.attributes.x.value), y: Number(c.attributes.y.value) });
          }
        }
        if (vertices.length > 0) {
          gedge.vertices = vertices;
        }

        console.log(gedge);
      }
    // check node types
    } else if (lelem.nodeName == 'startEvent') {
      gnode = this.createNode('startEvent',id);
    } else if (lelem.nodeName == 'userTask') {
      gnode = this.createNode(lelem.nodeName,id);
    } else if (lelem.nodeName == 'serviceTask') {
      gnode = this.createNode('webservice',id);
    } else if (lelem.nodeName == 'scriptTask') {
      gnode = this.createNode(lelem.nodeName,id);
    } else if (lelem.nodeName == 'endEvent') {
      gnode = this.createNode('endEvent',id);
    } else if (lelem.nodeName == 'exclusiveGateway') {
      gnode = this.createNode(lelem.nodeName,id);
    }

    if (!gnode && !gedge) {
      console.warn('Unimplemented BPMN Element: ' + lelem.nodeName);
    }

    // add node if found
    if (gnode) {
      shape = xmlutils.firstchild(node.children,'Bounds');
      if (lelem.attributes.name) {
        gnode.label = lelem.attributes.name.value;
      }
      data.graph.nodes.push(gnode);
      if (shape) {
        gnode.x = Number(shape.attributes['x'].value);
        gnode.y = Number(shape.attributes['y'].value);
      }
    // add edge if found
    } else if (gedge) {
      data.graph.edges.push(gedge);
    }

  }

}
